<template>
  <div class="pc_banner">
    <!-- 搜索 -->
    <div class="pc_select">
      <el-row>
        <el-col :span="20"
          ><div class="grid-content bg-purple">
            <el-form
              :inline="true"
              :model="selectForm"
              class="demo-form-inline"
              @submit.native.prevent
            >
              <el-form-item label="">
                <el-select
                  v-model="selectForm.type"
                  clearable
                  @clear="handleClear"
                  placeholder="请选择科目"
                  ref="selectref1"
                   @keydown.enter.native="handleEnterChange('selectref1')"
                >
                  <el-option
                    v-for="item in poslist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  v-model="selectForm.keyword"
                  clearable
                  @clear="handleClear"
                  placeholder="请输入课件教案标题"
                   ref="selectref2"
                   @keydown.enter.native="handleEnterChange('selectref2')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSelect">搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span="2"
          ><div class="grid-content bg-purple">&nbsp;</div></el-col
        >
        <el-col :span="2"
          ><div class="grid-content bg-purple-light">
            <div class="cratebtn">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="createEvents"
                >新增课件教案内容</el-button
              >
            </div>
          </div></el-col
        >
      </el-row>
    </div>
    <!-- 表格区域 -->
    <el-table
      :data="getTabeData"
      border
      v-loading="loading"
      style="width: 100%"
      height="580"
    >
      <el-table-column
        fixed
        prop="id"
        :label="label.id"
        width="80"
      ></el-table-column>
      <el-table-column prop="typename" :label="label.typename" width="100">
      </el-table-column>
      <el-table-column
        prop="title"
        label="课件标题"
        width="150"
      ></el-table-column>
      <el-table-column prop="logo" :label="label.logo" width="190">
        <template slot-scope="scope">
          <img :src="scope.row.logo" alt="课件封面图" class="imgs" />
        </template>
      </el-table-column>
      <el-table-column
        prop="plan_title"
        :label="label.plan_title"
        width="150"
      ></el-table-column>
      <el-table-column prop="plan_logo" :label="label.plan_logo" width="190">
        <template slot-scope="scope">
          <img :src="scope.row.plan_logo" alt="教案封面图" class="imgs" />
        </template>
      </el-table-column>
      <el-table-column prop="status" :label="label.status" width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === 0">上线</el-tag>
          <el-tag type="warning" v-else>待上线</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="publish_time"
        :label="label.publish_time"
        width="190"
      >
      </el-table-column>
      <el-table-column
        prop="create_time"
        :label="label.create_time"
        width="190"
      >
      </el-table-column>
      <el-table-column
        prop="update_time"
        :label="label.update_time"
        width="190"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="220">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <el-button
              @click="handleLookClick(scope.row)"
              type="primary"
              icon="el-icon-view"
              size="small"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button
              type="success"
              icon="el-icon-edit"
              size="small"
              @click="handleClick(scope.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              @click="handleDeleteClick(scope.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pc_pages">
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="sizes"
          :page-size="sizePage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="EditorDialogVisible"
      width="60%"
      :lock-scroll="false"
      @closed="closed('edtiorForms')"
    >
      <el-form
        :label-position="'lift'"
        label-width="100px"
        :model="editorForm"
        ref="edtiorForms"
        :rules="ruleForms"
        :validate-on-rule-change="false"
      >
        <el-form-item :label="label.id" prop="id">
          <el-input v-model="editorForm.id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="label.typename" prop="type">
          <el-select v-model="editorForm.type" placeholder="请选择科目">
            <el-option
              v-for="item in poslist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="label.title" prop="tilte">
          <el-input v-model="editorForm.title"></el-input>
        </el-form-item>
        <el-form-item :label="label.intro" prop="intro">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="editorForm.intro"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="label.logo" prop="logo">
          <Upload
            v-if="EditorDialogVisible"
            :initUrl="editorForm.logo"
            @change="handleUploadSuccess($event, editorForm, 'logo')"
          ></Upload>
        </el-form-item>
        <el-form-item :label="label.content" prop="content">
          <InUpload
            v-if="EditorDialogVisible"
            :actionUrl="savePdf"
            :initUrl="editorForm.content"
            @change="handleUploadSuccess($event, editorForm, 'content')"
          ></InUpload>
        </el-form-item>
        <el-form-item :label="label.plan_title" prop="plan_title">
          <el-input v-model="editorForm.plan_title"></el-input>
        </el-form-item>
        <el-form-item :label="label.plan_logo" prop="plan_logo">
          <Upload
            v-if="EditorDialogVisible"
            :initUrl="editorForm.plan_logo"
            @change="handleUploadSuccess($event, editorForm, 'plan_logo')"
          ></Upload>
        </el-form-item>
        <el-form-item :label="label.plan_content" prop="plan_content">
          <InUpload
            v-if="EditorDialogVisible"
            :actionUrl="savePdf"
            :initUrl="editorForm.plan_content"
            @change="handleUploadSuccess($event, editorForm, 'plan_content')"
          ></InUpload>
        </el-form-item>
        <el-form-item label="视频">
          <InUpload
            v-if="EditorDialogVisible"
            :initUrl="editorForm.video"
            @change="handleUploadSuccess($event, editorForm, 'video')"
          ></InUpload>
        </el-form-item>
        <el-form-item label="素材">
          <InUpload
            v-if="EditorDialogVisible"
            :initUrl="editorForm.reference"
            @change="handleUploadSuccess($event, editorForm, 'reference')"
          ></InUpload>
        </el-form-item>
        <el-form-item label="练习">
          <InUpload
            v-if="EditorDialogVisible"
            :actionUrl="savePdf"
            :initUrl="editorForm.homework"
            @change="handleUploadSuccess($event, editorForm, 'homework')"
          ></InUpload>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="editorForm.status" placeholder="请选择状态">
            <el-option label="上线" value="0"></el-option>
            <el-option label="待上线" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上次更新时间">
          <el-input
            v-model="editorForm.update_time"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditorDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="EditorSubmit('edtiorForms')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="lookEventDialogVisible"
      width="60%"
      :lock-scroll="false"
      @closed="closed('lookForm')"
    >
      <el-form
        :label-position="'lift'"
        label-width="120px"
        :model="lookForm"
        ref="lookForm"
        :validate-on-rule-change="false"
      >
        <el-form-item :label="label.id + ':'">
          <el-tag type="success">{{ lookForm.id }}</el-tag>
        </el-form-item>
        <el-form-item :label="label.typename + ':'">
          <el-tag type="success">{{ lookForm.typename }}</el-tag>
        </el-form-item>
        <el-form-item :label="label.title + ':'">
          <el-tag type="success">{{ lookForm.title }}</el-tag>
        </el-form-item>
        <el-form-item :label="label.intro + ':'">
          <span>{{ lookForm.intro }}</span>
        </el-form-item>
        <el-form-item :label="label.logo + ':'">
          <EnlargeImg :imgUrl="lookForm.logo"></EnlargeImg>
        </el-form-item>
        <el-form-item :label="label.content + ':'">
          <span>{{ lookForm.content }}</span>
        </el-form-item>
        <el-form-item :label="label.plan_title + ':'">
          <el-tag type="success">{{ lookForm.plan_title }}</el-tag>
        </el-form-item>
        <el-form-item :label="label.plan_logo + ':'">
          <EnlargeImg :imgUrl="lookForm.plan_logo"></EnlargeImg>
        </el-form-item>
        <el-form-item :label="label.plan_content + ':'">
          <span>{{ lookForm.plan_content }}</span>
        </el-form-item>
        <el-form-item label="视频 :">
          <span>{{ lookForm.video }}</span>
        </el-form-item>
        <el-form-item label="素材 :">
          <span>{{ lookForm.reference }}</span>
        </el-form-item>
        <el-form-item label="练习 :">
          <span>{{ lookForm.homework }}</span>
        </el-form-item>
        <el-form-item :label="label.status + ':'">
          <el-tag type="success" v-if="lookForm.status === 0">上线</el-tag>
          <el-tag type="success" v-else>待上线</el-tag>
        </el-form-item>
        <el-form-item :label="label.publish_time + ':'">
          <el-tag type="success">{{ lookForm.publish_time }}</el-tag>
        </el-form-item>
        <el-form-item :label="label.create_time + ':'">
          <el-tag type="success">{{ lookForm.create_time }}</el-tag>
        </el-form-item>
        <el-form-item :label="label.update_time + ':'">
          <el-tag type="success">{{ lookForm.update_time }}</el-tag>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookEventDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 新增的弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="createEventDialog"
      width="60%"
      :lock-scroll="false"
      @closed="closed('createForm')"
    >
      <el-form
        :model="newEventForm"
        ref="createForm"
        :rules="ruleForms"
        label-width="130px"
        :validate-on-rule-change="false"
      >
        <el-form-item :label="label.typename" prop="type">
          <el-select v-model="newEventForm.type" placeholder="请选择科目信息">
            <el-option
              v-for="item in poslist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="label.title" prop="title">
          <el-input
            v-model="newEventForm.title"
            placeholder="请输入课堂教学标题"
          ></el-input>
        </el-form-item>
        <el-form-item :label="label.intro" prop="intro">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入简介"
            v-model="newEventForm.intro"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="label.logo" prop="logo">
          <Upload
            v-if="createEventDialog"
            @change="handleUploadSuccess($event, newEventForm, 'logo')"
          ></Upload>
        </el-form-item>
        <el-form-item :label="label.content" prop="content">
          <Upload
            v-if="createEventDialog"
            :actionUrl="savePdf"
            :listType="'text'"
            :tipText="'请上传pdf格式的文件'"
            @change="handleUploadSuccess($event, newEventForm, 'content')"
          ></Upload>
        </el-form-item>
        <el-form-item :label="label.plan_title" prop="plan_title">
          <el-input
            v-model="newEventForm.plan_title"
            placeholder="请输入教案规划标题"
          ></el-input>
        </el-form-item>
        <el-form-item :label="label.plan_logo" prop="plan_logo">
          <Upload
            v-if="createEventDialog"
            @change="handleUploadSuccess($event, newEventForm, 'plan_logo')"
          ></Upload>
        </el-form-item>
        <el-form-item :label="label.plan_content" prop="plan_content">
          <Upload
            v-if="createEventDialog"
            :actionUrl="savePdf"
            :listType="'text'"
            :tipText="'请上传pdf格式的文件'"
            @change="handleUploadSuccess($event, newEventForm, 'plan_content')"
          ></Upload>
        </el-form-item>
        <el-form-item label="视频">
          <Upload
            v-if="createEventDialog"
            @change="handleUploadSuccess($event, newEventForm, 'video')"
          ></Upload>
        </el-form-item>
        <el-form-item label="素材">
          <Upload
            v-if="createEventDialog"
            @change="handleUploadSuccess($event, newEventForm, 'reference')"
          ></Upload>
        </el-form-item>
        <el-form-item label="练习">
          <Upload
            v-if="createEventDialog"
            :actionUrl="savePdf"
            :listType="'text'"
            :tipText="'请上传pdf格式的文件'"
            @change="handleUploadSuccess($event, newEventForm, 'homework')"
          ></Upload>
        </el-form-item>
        <el-form-item :label="label.publish_time" prop="publish_time">
          <DatePicker
            @change="getDate($event, newEventForm, 'publish_time')"
          ></DatePicker>
        </el-form-item>
        <el-form-item :label="label.status" prop="status">
          <el-select v-model="newEventForm.status" placeholder="请选择上线状态">
            <el-option label="上线" value="0"></el-option>
            <el-option label="待上线" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createEventDialog = false">取 消</el-button>
        <el-button type="primary" @click="createEvent('createForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pcPlanRules } from 'untils/form_validation.js';
import Upload from 'common/upload/Upload';
import InUpload from 'common/upload/InUpload';
import EnlargeImg from 'common/enlargeimg/EnlargeImg';
import DatePicker from 'common/datepicker/DatePicker';
import {
  initPlanList,
  initPostList,
  savePlans,
  findPlans,
  deletePlans
} from 'api/post/postApi.js';

export default {
  name: 'pc_plan',
  components: { Upload, EnlargeImg, DatePicker, InUpload },
  data() {
    return {
      savePdf: '/v1/courseware/pdfSave',
      label: {
        id: 'ID',
        typename: '科目',
        title: '课件标题',
        intro: '简介',
        logo: '课件封面图',
        content: '课件内容',
        plan_title: '教案标题',
        plan_logo: '教案封面图',
        plan_content: '教案内容',
        status: '状态',
        publish_time: '发布时间',
        create_time: '创建时间',
        update_time: '更新时间'
      },
      loading: true,
      tableData: [],
      // 分页功能参数
      total: 0,
      sizes: [10, 20, 30, 40],
      sizePage: 10,
      currentPage: 1,
      selectForm: {
        type: '',
        keyword: ''
      },
      EditorDialogVisible: false,
      lookEventDialogVisible: false,
      createEventDialog: false,
      ruleForms: null,
      lookForm: {},
      editorForm: {},
      newEventForm: {},
      poslist: [], // 科目信息
      title: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      isShow: true,
      isUpload: false
    };
  },
  created() {
    // 数据初始化
    this.initData();
  },
  // 计算属性
  computed: {
    // 分页控制
    getTabeData: function () {
      const tableData = this.tableData.slice(
        (this.currentPage - 1) * this.sizePage,
        this.currentPage * this.sizePage
      );
      return tableData;
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initPlanList();
      this.tableData = res.data;
      // 类目列表
      const { data: poslist } = await initPostList();
      this.poslist = poslist.data.options;
      this.total = res.data.length;
      this.loading = false;
    },
    // 分页功能实现
    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 编辑
    async handleClick(evetsId) {
      this.title = '编辑';
      this.ruleForms = pcPlanRules;
      const params = { id: evetsId };
      const { data: res } = await findPlans(params);
      this.editorForm = res.data;
      // 修改数据类型，以作数据回显
      this.editorForm.status = this.editorForm.status.toString();
      this.EditorDialogVisible = true;
    },
    // 查看
    handleLookClick(data) {
      this.title = '当前信息';
      this.lookForm = data;
      this.lookEventDialogVisible = true;
    },
    // 更新
    async EditorSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // alert('submit!');
          const { data: res } = await savePlans(this.editorForm);
          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('更新失败！');
          } else {
            this.$message.success('更新成功！');
            this.initData();
          }
          this.EditorDialogVisible = false;
        } else {
          this.$message.error('表单验证未通过！');
          return false;
        }
      });
    },
    // 公用的dialog清空逻辑
    closed(fomrName) {
      this.editorForm = {};
      this.lookForm = {};
      this.newEventForm = {};
      this.ruleForms = null;
      this.resetForm(fomrName);
    },
    // 删除
    async handleDeleteClick(eventId) {
      // 询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该信息, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除！');
      }
      const params = { id: eventId };
      const { data: res } = await deletePlans(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('删除失败！');
      } else {
        this.$message.success('删除成功！');
      }
      this.initData();
    },
    // 新增赛事按钮
    createEvents() {
      this.title = '新增课件教案';
      this.ruleForms = pcPlanRules;
      this.createEventDialog = true;
    },
    // 提交新增表单
    createEvent(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await savePlans(this.newEventForm);
          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('新增失败！');
          } else {
            this.$message.success('新增成功！');
            this.initData();
          }
          this.createEventDialog = false;
        } else {
          this.$message.error('表单验证未通过！');
          return false;
        }
      });
    },
    // 清除验证提示
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 图片上传功能实现
     */
    // 上传图片成功时的公用方法
    handleUploadSuccess(path, form, item) {
      form[item] = path;
    },
    getDate(value, form, item) {
      form[item] = value;
    },
    // 搜索实现
    async onSelect() {
      const { data: res } = await initPlanList(this.selectForm);
      if (res.status !== 0) {
        this.$message.error('查找失败！');
        return;
      }
      this.$message.success('查找成功！');
      this.tableData = res.data;
      this.total = res.data.length;
    },
    // 回车阻止多选框弹出下拉框
    handleEnterChange(refName) {
      this.onSelect();
      this.$refs[refName].visible = false;
    },
    // 搜索重置
    handleClear() {
      this.selectForm={};
      this.initData();
    },
    // 上传组件与input的切换显示
    handlerShowInput() {
      this.isShow = false;
      this.isUpload = true;
    }
  }
};
</script>

<style scoped>
.pc_pages {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.pc_select {
  width: 100%;
}
.imgs {
  width: 170px;
  height: 100px;
}
.img_show {
  width: 300px;
  height: 200px;
}
.cratebtn {
  float: right;
}
</style>